import { React, PT } from '@gasbuddy/react';
import { Image } from 'semantic-ui-react';

const MAX_LEADING_ZEROES = 2;

function getSizeDimension(size) {
  return {
    Medium: 92,
    Large: 155,
    Small: 46,
  }[size] || 46;
}

export function buildDimsWithLeadingZeros(size, logoVersion) {
  const numZeroes = (logoVersion || 0) % MAX_LEADING_ZEROES;
  const zeroes = '0'.repeat(numZeroes);
  return `autox${zeroes}${getSizeDimension(size)}`;
}

export function appendVersionQuery(url, logoVersion) {
  return `${url}?v=${logoVersion}`;
}

export function getUrlBySize(size, imageUrl, logoVersion) {
  const dims = buildDimsWithLeadingZeros(size, logoVersion);
  let url = `https://images.gasbuddy.io/${dims}/b/0.png`; // Default
  if (imageUrl) {
    const pathStart = imageUrl.indexOf('/', imageUrl.indexOf('://') + 3);
    const base = imageUrl.substring(0, pathStart);
    const suffix = imageUrl.substring(pathStart + 1);
    url = `${base}/${dims}/${suffix}`;
  }
  return appendVersionQuery(url, logoVersion);
}

export const BrandLogo = ({ brand, size }) => {
  let brandName = 'Brand name';
  let brandUrl;
  if (brand) {
    if (brand.name) { brandName = brand.name; }
    if (brand.image_url) {
      brandUrl = getUrlBySize(size, brand.image_url, brand.logo_version || 0);
    }
  }
  const defaultLogo = getUrlBySize(size, 0, 1);
  if (!brandUrl) { brandUrl = defaultLogo; }
  return (
    <Image src={brandUrl} alt={brandName} onError={(e) => { e.target.src = defaultLogo; }} />
  );
};

BrandLogo.defaultProps = {
  brand: {},
  size: 'Small',
};

BrandLogo.propTypes = {
  brand: PT.shape(
    {
      image_url: PT.string,
      name: PT.string,
      brand_id: PT.number,
      logo_version: PT.number,
    },
  ),
  size: PT.oneOf(['Small', 'Medium', 'Large']),
};
